/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { getBase64Format } from 'api/helpers/people';
import { FETCH_SAMPLE_CSV, POST_CREATE_ACCOUNTS_CSV } from 'redux/sagas/actions/people';
import { DISABLE_POST_CSV_SUCCESS_FLAG } from 'redux/slices/people';
import { Button } from 'ui/atoms';
import MainFont from 'ui/typography/mainFont';

import { DragDrop } from '..';
import CreateAccount from '../CreateAccount';
import PeopleHistory from '../PeopleHistory';

import {
  AddContainer,
  Box,
  Divider,
  LinkWrapper,
  ProceedButtonContainer,
  TitleWrapper,
  UploaderLink,
  UploaderTitle
} from './style';
import { SpinnerIcon } from '../../atoms/Table/style';
import spinnerIconWhite from '../../assets/img/spinner-icon-white.png';
import { AcceptButtonContainer } from '../CreateAccount/style';

const PeopleSideBar = ({
  postCSVSuccess,
  disablePostCSVSuccessFlag,
  corporate,
  uploadCSV,
  downloadSampleCSV,
  callbackSidebar,
  isLoadingCreationBulk
}) => {
  const { t } = useTranslation();

  const [showAddAccount, setShowAddAccount] = useState(true);
  const [errorDragDrop, setErrorDragDrop] = useState(true);
  const [selectedFile, setSelectedFile] = useState();
  const [errorLengthFile, setErrorLengthFile] = useState();

  useEffect(() => {
    if (postCSVSuccess) {
      setShowAddAccount(false);
      disablePostCSVSuccessFlag();
    }
  }, [disablePostCSVSuccessFlag, postCSVSuccess]);

  useEffect(() => {
    if (selectedFile && selectedFile.name.length > 51) {
      setErrorLengthFile(true);
    } else {
      setErrorLengthFile(false);
    }
  }, [selectedFile]);

  const onSubmitFile = e => {
    e.preventDefault();
    getBase64Format(selectedFile, result => {
      uploadCSV(result, selectedFile.name);
    });
  };

  return (
    <>
      <TitleWrapper>
        <Box highlight={showAddAccount} onClick={() => setShowAddAccount(true)}>
          <MainFont type={showAddAccount ? 'highlightText' : '1'}>
            {t('add_account')}
          </MainFont>
        </Box>
        <Box
          highlight={!showAddAccount}
          onClick={() => setShowAddAccount(false)}
        >
          <MainFont type={!showAddAccount ? 'highlightText' : '1'}>
            {t('history')}
          </MainFont>
        </Box>
      </TitleWrapper>

      {showAddAccount && (
        <AddContainer>
          <CreateAccount />
          <Divider />
          <UploaderTitle>
            <MainFont type="createAccountHeaders">{t('import_csv')}</MainFont>
          </UploaderTitle>
          <UploaderLink>
            <LinkWrapper onClick={downloadSampleCSV}>
              {t('download_sample_csv')}
            </LinkWrapper>
          </UploaderLink>
          <form onSubmit={onSubmitFile}>
            <DragDrop
              handleError={setErrorDragDrop}
              setSelectedFile={setSelectedFile}
              selectedFile={selectedFile}
              validExtensions={['application/vnd.ms-excel', 'text/csv']}
              maxSize={1024 ** 2}
              titleType="createAccountHeaders"
            />
            {errorLengthFile && (
              <MainFont type="errorLabel">{t('error_length_file')}</MainFont>
            )}
            {isLoadingCreationBulk ? (
              <AcceptButtonContainer id="button-container">
                <Button variant="accept-button" noPadding>
                  <SpinnerIcon icon={spinnerIconWhite} marginRight={11} />
                  <MainFont type="addAccountLabels">{t('loading')}</MainFont>
                </Button>
              </AcceptButtonContainer>
            ) : (
              <ProceedButtonContainer>
                <Button
                  type="submit"
                  variant="accept-button"
                  disabled={errorDragDrop || errorLengthFile}
                >
                  <MainFont type="addAccountLabels"> {t('proceed')} </MainFont>
                </Button>
              </ProceedButtonContainer>
            )}
          </form>
        </AddContainer>
      )}
      {!showAddAccount && <PeopleHistory />}
    </>
  );
};

PeopleSideBar.propTypes = {
  uploadCSV: PropTypes.func,
  downloadSampleCSV: PropTypes.func,
  postCSVSuccess: PropTypes.bool,
  disablePostCSVSuccessFlag: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  corporate: PropTypes.bool,
  callbackSidebar: PropTypes.func,
  isLoadingCreationBulk: PropTypes.bool
};

export default connect(
  state => ({
    postCSVSuccess: state.people?.postCSVSuccess,
    isLoadingCreationBulk: state?.people?.isLoadingCreationBulk
  }),
  dispatch => ({
    disablePostCSVSuccessFlag: () =>
      dispatch({ type: DISABLE_POST_CSV_SUCCESS_FLAG }),
    uploadCSV: (fileData, filename) =>
      dispatch({
        type: POST_CREATE_ACCOUNTS_CSV._REQUEST,
        payload: { file: fileData, name: filename }
      }),
    downloadSampleCSV: () => dispatch({ type: FETCH_SAMPLE_CSV._REQUEST })
  })
)(PeopleSideBar);
